import { supabase } from '../lib/supabase';
import { normalizeMilestoneNameOptions } from '../lib/milestoneNameOptions';

export async function fetchMilestoneNameOptionsCatalog() {
  const { data, error } = await supabase
    .from('milestone_name_options')
    .select('id, code, label, category, sort_order')
    .eq('is_active', true)
    .order('sort_order', { ascending: true })
    .order('label', { ascending: true });

  if (error) {
    console.error('[fetchMilestoneNameOptionsCatalog]', error);
    throw error;
  }
  return normalizeMilestoneNameOptions(data);
}

export async function fetchTemplateNameOptions(milestoneTemplateId) {
  if (!milestoneTemplateId) return [];

  const { data, error } = await supabase
    .from('milestone_template_name_options')
    .select(
      'sort_order, option:milestone_name_options(id, code, label, category, sort_order, is_active)'
    )
    .eq('milestone_template_id', milestoneTemplateId)
    .order('sort_order', { ascending: true });

  if (error) {
    console.error('[fetchTemplateNameOptions]', error);
    return [];
  }

  const options = (data || [])
    .map((row) => row.option)
    .filter((o) => o && o.is_active !== false);

  return normalizeMilestoneNameOptions(options);
}

export async function fetchTemplateNameOptionsByMilestoneIds(milestoneTemplateIds) {
  const ids = [...new Set((milestoneTemplateIds || []).filter(Boolean))];
  if (!ids.length) return {};

  const { data, error } = await supabase
    .from('milestone_template_name_options')
    .select(
      'milestone_template_id, sort_order, option:milestone_name_options(id, code, label, category, sort_order, is_active)'
    )
    .in('milestone_template_id', ids)
    .order('sort_order', { ascending: true });

  if (error) {
    console.error('[fetchTemplateNameOptionsByMilestoneIds]', error);
    return {};
  }

  const map = {};
  for (const row of data || []) {
    const tid = row.milestone_template_id;
    if (!map[tid]) map[tid] = [];
    if (row.option && row.option.is_active !== false) {
      map[tid].push(row.option);
    }
  }
  for (const tid of Object.keys(map)) {
    map[tid] = normalizeMilestoneNameOptions(map[tid]);
  }
  return map;
}

export async function replaceMilestoneTemplateNameOptions(milestoneTemplateId, optionIds) {
  if (!milestoneTemplateId) return;

  const { error: delError } = await supabase
    .from('milestone_template_name_options')
    .delete()
    .eq('milestone_template_id', milestoneTemplateId);

  if (delError) throw delError;

  const uniqueIds = [...new Set((optionIds || []).filter(Boolean))];
  if (!uniqueIds.length) return;

  const rows = uniqueIds.map((optionId, index) => ({
    milestone_template_id: milestoneTemplateId,
    option_id: optionId,
    sort_order: index,
  }));

  const { error: insError } = await supabase
    .from('milestone_template_name_options')
    .insert(rows);

  if (insError) throw insError;
}
